import zenscroll from 'zenscroll';

const duration = 500;

const offset = 100;

zenscroll.setup(duration, 0);

function getTargetY(targetElement: HTMLElement) {
    return zenscroll.getTopOf(targetElement) || 0;
}

function getAdditionalOffset(targetElement: HTMLElement) {
    return parseFloat(window.getComputedStyle(targetElement, null).getPropertyValue('padding-top') || '0');
}

const focusLink = (targetElement: HTMLElement | null) => {
    if (!targetElement) return;
    const link = targetElement.querySelector<HTMLAnchorElement>('a');
    if (!link) return;
    link.focus();
};

// Use to smooth scroll to anchor on same page
const smoothScroll = (hash: string, event?: React.SyntheticEvent | MouseEvent) => {
    if (event) event.preventDefault();
    if (!hash || !hash.length) return;
    if (hash === '#!') return;
    let targetElement = document.querySelector<HTMLElement>(hash);
    if (targetElement === null) return;

    const hasPageSection = targetElement.classList.contains('page-section');
    if (!hasPageSection) targetElement = targetElement.querySelector<HTMLElement>('.page-section');
    if (targetElement === null) return;

    const targetY = getTargetY(targetElement);
    const additionalOffset = getAdditionalOffset(targetElement);

    zenscroll.toY(targetY + additionalOffset - offset, duration, () => focusLink(targetElement));
};

const smoothScrollToCenter = (event: React.SyntheticEvent | MouseEvent, vOffset = 0) => {
    event.preventDefault();
    zenscroll.center(event.currentTarget as HTMLElement, duration, vOffset);
};

const smoothScrollToElement = (targetElement: HTMLElement, vDuration = duration, vOffset = 0) => {
    const targetY = getTargetY(targetElement);
    const additionalOffset = getAdditionalOffset(targetElement);
    zenscroll.toY(targetY + additionalOffset - vOffset, vDuration);
};

const smoothScrollToTop = (vDuration = duration, vOffset = 0) => {
    const targetElement = document.body as HTMLElement;
    const targetY = getTargetY(targetElement);
    const additionalOffset = getAdditionalOffset(targetElement);
    zenscroll.toY(targetY + additionalOffset - vOffset, vDuration);
};

export { smoothScroll as default, smoothScrollToCenter, focusLink, smoothScrollToElement, smoothScrollToTop };
